import { BulbOutlined, CoffeeOutlined, SmileOutlined } from '@ant-design/icons';
import { BasePromptItem } from '@ant-design/x/es/prompts';

export type PromptDataItem = BasePromptItem;

export const promptData: PromptDataItem[] = [
  {
    key: '1',
    icon: <BulbOutlined style={{ color: '#FFD700' }} />,
    description: '工厂管理要关注哪些方面',
  },
  {
    key: '2',
    icon: <CoffeeOutlined style={{ color: '#964B00' }} />,
    description: '写一篇简洁清晰的日报',
  },
  {
    key: '3',
    icon: <SmileOutlined style={{ color: '#FAAD14' }} />,
    description: '推荐一些关于奋斗成就梦想的优秀范文',
  },
];
